import { Outlet } from 'react-router-dom';
import {
  Copilot,
  useUserTimeTracking,
  api,
  VisibilityContext,
  AppDataContext,
} from '@acilearning/ibl-web-react-common';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import './DashboardView.css';
import { useContext, useEffect, useState } from 'react';
import useIframeMessage from '../../hooks/useIframeMessage';
import { getTenantMetaData } from '../../hooks/utils/tenant';
import AciLogo from  './Assets/ACI_Logo.svg'      
import closebtn from './Assets/closebtn.png'    
import mentorbtn from './Assets/pushBtn.png'
const SHOW_MENTOR = process.env.REACT_APP_IBL_ENABLE_MENTOR === 'true';

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const DashboardView = () => {
  const { visibilityData } = useContext(VisibilityContext);
  const { setTenantMetaData, appData } = useContext(AppDataContext);
  const [mentorDisplayEnabled, setMentorDisplayEnabled] = useState(false);
  const [SHOW_MENTOR, setShowMentor] = useState(process.env.REACT_APP_IBL_ENABLE_MENTOR === 'true')


    const [flag, setFlag] = useState(true)
  useIframeMessage();
  useUserTimeTracking(api);

  const closeFunc = () => {
    setShowMentor(!SHOW_MENTOR)
  }
  useEffect(() => {
    closeFunc()
  }, [])

  const minimizeMentor = () => {
    setFlag(!flag)
  }
  useIframeMessage();
  useUserTimeTracking(api);



  useEffect(() => {
    getTenantMetaData((data) => {
      setTenantMetaData(data?.metadata ?? {});
      if (SHOW_MENTOR) {
        let mentorAIEnabled = data?.metadata?.enable_sidebar_ai_mentor_display !== false
        if(mentorAIEnabled){
          mentorAIEnabled=appData?.userMetaData?.public_metadata?.enable_sidebar_ai_mentor_display!== false
        }
        setMentorDisplayEnabled(
          mentorAIEnabled
        );
      }
    });
  }, [appData.userMetaData.public_metadata]);

  return (
    <span>
      <span
        className={`af-view ${true? 'use-full-width' : ''}`}
      >
        <div className="body">
          <div className="full">
            <div
            className={`main-content ${inIframe() ? '' : 'not-in-iframe'}`}
               style={{
                ...(false? {} : { paddingRight: 'unset' }),
                ...(inIframe()
                  ? { marginRight: '0px', paddingRight: '0px' }
                  : {}),
              }}
            >
              <div id="view_wrapper" className="div-block-326">
                {!inIframe() && visibilityData.showHeader && <Header></Header>}
                {/*{!inIframe() && <MobileHeader></MobileHeader>}*/}
                <Outlet />
                {!inIframe() && <Footer></Footer>}
              </div>
              {/*<CopilotLauncher />*/}
            </div>
            <div>
              {!inIframe() && false  && <div className='mentor-frame'
                style={{
                  transform: !flag ? 'translateY(-50%)' : 'translateY(-155%)', // Center vertically
                  // marginRight: '20px', // Adjust as needed
                  borderRadius: flag ? '14px' : '4px',
                  marginRight: flag ? '0px' : '20px',
                  width:flag?'' :'29rem'
                }}
              >
                <div className='close-mtr-btn'
                  style={{
                    display: flag ? 'block' : 'none',
                  }}
                  onClick={() => minimizeMentor()}
                > <img
                    src={mentorbtn}
                    alt={'logo'}
                  /></div>
                <div className='expand-mentor' style={{display: !flag ? 'flex' : 'none'}}>
                  <div className='btn-wrap'>
                    <span className='logo-span' ><img
                      src={AciLogo}
                      alt={'logo'}
                      width={'60px'}
                    /></span>
                    <button className='close-btn' onClick={() => minimizeMentor()}>
                       <img
                      src={closebtn}
                      alt={'logo'}
                      width={'30px'}
                    /></button>
                  </div>
                  <div className="bottom-area" style={{ height: '800px', overflowY: 'auto' }}> 
                    <div className='copilot-wrap'>

                    <Copilot />
                  </div></div>
                </div>
              </div>}
            </div>
            {/*<CopilotCloser />*/}
          </div>
          {/*<CopilotLauncher />*/}
        </div>
      </span>
    </span>
  );
};

export default DashboardView;
